import { Typography } from "@mui/material";
import * as React from "react";

import {
  RobotoLinkHoverUnderline,
  RobotoTableCell,
  RobotoTableRow,
} from "@/shared/components";
import { UserLink } from "@/shared/components/UserLink";
import { CollectionRecord } from "@/shared/domain/collections";

import styles from "./CollectionRow.module.css";

interface CollectionRowProps {
  collection: CollectionRecord;
}

export const CollectionRow: React.FC<CollectionRowProps> = ({ collection }) => {
  const numDatasets = collection.resources["dataset"]?.length || 0;
  const numFiles = collection.resources["file"]?.length || 0;

  return (
    <RobotoTableRow className={styles.tableRow}>
      <RobotoTableCell
        className={styles.td}
        title={collection.name || collection.collection_id}
      >
        <RobotoLinkHoverUnderline
          to={`/collections/${collection.collection_id}`}
        >
          <Typography
            component={"abbr"}
            title={collection.name || collection.collection_id}
            className={styles.collectionNameText}
            variant={"body2"}
          >
            {collection.name || collection.collection_id}
          </Typography>
        </RobotoLinkHoverUnderline>
      </RobotoTableCell>
      <RobotoTableCell className={styles.td} title={collection.collection_id}>
        {collection.collection_id}
      </RobotoTableCell>
      <RobotoTableCell className={styles.td}>
        {numDatasets + numFiles}
      </RobotoTableCell>
      <RobotoTableCell
        className={styles.td}
        title={new Date(collection.created).toLocaleString()}
      >
        {new Date(collection.created).toLocaleString()}
      </RobotoTableCell>
      <RobotoTableCell
        className={styles.td}
        title={collection.updated_by || undefined}
      >
        {collection.updated_by.includes("@") ? (
          <UserLink userId={collection.updated_by} />
        ) : (
          collection.updated_by
        )}
      </RobotoTableCell>
      <RobotoTableCell
        className={styles.td}
        title={new Date(collection.updated).toLocaleString()}
      >
        {new Date(collection.updated).toLocaleString()}
      </RobotoTableCell>
      <RobotoTableCell className={styles.tdDescription}>
        {collection.description}
      </RobotoTableCell>
      <RobotoTableCell className={styles.td}>
        {collection.resource_type.charAt(0).toUpperCase() +
          collection.resource_type.slice(1)}
      </RobotoTableCell>
    </RobotoTableRow>
  );
};
